var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoXy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEC\xA2\x8C\xED\x91\x9C"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 136",
    filter: "url(#filter0_d_1898_9666)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 14,
    fill: "#EB2828"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 13.5,
    stroke: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18 11C14.1344 11 11 14.1344 11 18C11 21.8656 14.1344 25 18 25C21.8656 25 25 21.8656 25 18C24.9922 14.1344 21.8656 11 18 11ZM18.5833 23.8022V22.6667C18.5833 22.3478 18.3189 22.0833 18 22.0833C17.6811 22.0833 17.4167 22.3478 17.4167 22.6667V23.8022C14.6556 23.5222 12.4778 21.3367 12.1978 18.5833H13.3333C13.6522 18.5833 13.9167 18.3189 13.9167 18C13.9167 17.6811 13.6522 17.4167 13.3333 17.4167H12.1978C12.4778 14.6556 14.6633 12.4778 17.4167 12.1978V13.3333C17.4167 13.6522 17.6811 13.9167 18 13.9167C18.3189 13.9167 18.5833 13.6522 18.5833 13.3333V12.1978C21.3444 12.4778 23.5222 14.6633 23.8022 17.4167H22.6667C22.3478 17.4167 22.0833 17.6811 22.0833 18C22.0833 18.3189 22.3478 18.5833 22.6667 18.5833H23.8022C23.5222 21.3444 21.3367 23.5222 18.5833 23.8022ZM20.3333 18C20.3333 18.3189 20.0689 18.5833 19.75 18.5833H18.5833V19.75C18.5833 20.0689 18.3189 20.3333 18 20.3333C17.6811 20.3333 17.4167 20.0689 17.4167 19.75V18.5833H16.25C15.9311 18.5833 15.6667 18.3189 15.6667 18C15.6667 17.6811 15.9311 17.4167 16.25 17.4167H17.4167V16.25C17.4167 15.9311 17.6811 15.6667 18 15.6667C18.3189 15.6667 18.5833 15.9311 18.5833 16.25V17.4167H19.75C20.0689 17.4167 20.3333 17.6811 20.3333 18Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1898_9666",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.921569 0 0 0 0 0.156863 0 0 0 0 0.156863 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1898_9666"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1898_9666",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoXy);
export default __webpack_public_path__ + "static/media/ico-xy.3698e760a50089227e37bd7cdf4e07e4.svg";
export { ForwardRef as ReactComponent };